import React from "react";

const Divider = () => (
  <div className="divider">
    <div className="divider-line y" />
  </div>
);

export default Divider;
